// extracted by mini-css-extract-plugin
export default {"verify__links":"Verify_verify__links__0h0uT AuthPage_auth__links__ws-cL","verify":"Verify_verify__QJsfE"};